import { render } from "./SuppliersView.vue?vue&type=template&id=b99c9ea8&scoped=true"
import script from "./SuppliersView.vue?vue&type=script&lang=js"
export * from "./SuppliersView.vue?vue&type=script&lang=js"

import "./SuppliersView.vue?vue&type=style&index=0&id=b99c9ea8&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b99c9ea8"]])

export default __exports__